export function createScannerInput(options = {}) {
  const {
    getValue,
    setValue,
    getInput,
    onEnter,
    onScanEnd,
    clearOnScanStart = true,
    readonlyOnScan = false,
    trapTab = false,
    submitOnEnterAlways = false,
    scanThreshold = 50,
    idleTimeout = 300,
  } = options;

  let lastKeydownAt = 0;
  let unlockTimer = null;
  let isScanMode = false;
  let pendingKey = "";

  const syncReadonly = () => {
    if (!readonlyOnScan || !getInput) {
      return;
    }
    const input = getInput();
    if (input) {
      input.readOnly = isScanMode;
    }
  };

  const focus = () => {
    if (!getInput) {
      return;
    }
    const input = getInput();
    if (input) {
      input.focus();
    }
  };

  const reset = () => {
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
    isScanMode = false;
    lastKeydownAt = 0;
    pendingKey = "";
    syncReadonly();
  };

  const scheduleReset = () => {
    if (unlockTimer) {
      clearTimeout(unlockTimer);
    }
    unlockTimer = setTimeout(() => {
      reset();
    }, idleTimeout);
  };

  const handleKeydown = async (e) => {
    if (trapTab && e.key === "Tab") {
      e.preventDefault();
      focus();
      return;
    }

    if (e.key === "Enter") {
      if (!isScanMode && !submitOnEnterAlways) {
        return;
      }
      if (onEnter) {
        await onEnter(e);
      }
      if (onScanEnd) {
        onScanEnd(e);
      }
      reset();
      return;
    }

    if (e.ctrlKey || e.altKey || e.metaKey || e.key.length !== 1) {
      return;
    }

    const now = Date.now();
    const isRapidInput = lastKeydownAt && now - lastKeydownAt < scanThreshold;
    lastKeydownAt = now;

    if (!isScanMode && !isRapidInput) {
      pendingKey = e.key;
      return;
    }

    if (!isScanMode) {
      isScanMode = true;
      if (clearOnScanStart) {
        setValue("");
      }
      syncReadonly();
    }

    e.preventDefault();
    const prefix = pendingKey;
    pendingKey = "";
    setValue(`${getValue() || ""}${prefix}${e.key}`);
    scheduleReset();
  };

  return {
    focus,
    reset,
    handleKeydown,
    isScanMode: () => isScanMode,
  };
}
